/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    // Initialize desktop search
    this.desktopContainer = document.getElementById('Search-Drawer');
    this.mobileContainer = document.getElementById('mobile-menu');
    
    if (this.desktopContainer) {
      this.container = this.desktopContainer;
      this.form = this.container.querySelector('form.searchform');
      this.defaultTab = this.container.querySelector('.side-panel-content--initial');
      this.button = document.querySelectorAll('.thb-quick-search');
      this.reinitializeValues(this.container);
      this.setupEventListeners();
    }
    
    // Initialize mobile search if it exists
    if (this.mobileContainer) {
      this.container = this.mobileContainer;
      this.form = this.container.querySelector('form.mobile-search-form');
      this.button = this.container.querySelectorAll('.thb-mobile-search');
      this.reinitializeValues(this.container);
      this.setupEventListeners();
    }
  }
  reinitializeValues(container) {
    this.container = container; // Set the current container
    
    // Desktop search selectors
    if (container.id === 'Search-Drawer' || container.id === 'Search-Drawer-New') {
      // Try multiple selectors for search results container
      this.predictiveSearchResults = 
        this.container.querySelector('#desktop-search-result') ||
        this.container.querySelector('.side-panel-content--has-tabs');
        
      // Try multiple selectors for search input
      this.input = 
        this.container.querySelector('#side-panel-search-input') ||
        this.container.querySelector('#search-input') ||
        this.container.querySelector('input[type="search"]');
    } 
    // Mobile search selectors
    else if (container.id === 'mobile-menu') {
      this.predictiveSearchResults = this.container.querySelector('#mobile-search-result');
      this.input = this.container.querySelector('#mobile-search-input');
    }
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    // Søkefeltet i denne beholderen, så markøren havner i feltet når søket åpnes.
    const searchInput = this.input;


    document.querySelectorAll('input[type="search"]').forEach(input => {input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this))
    });

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();

        
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        if (this.container.classList.contains('active')) {
          setTimeout(function () {
            if (searchInput) {
              searchInput.focus({
                preventScroll: true
              });
            }
          }, 100);
          // dispatchCustomEvent('search:open');
        } 

        return false;
      });
    });
  }

  getQuery(event) {
    return event.target.value.trim();
  }

  onChange(event) {
    // Determine which search input triggered the event
    let container;
    const inputId = event.target.id;
    
    if (inputId === 'side-panel-search-input' || inputId === 'search-input') {
      // Try both possible container IDs
      container = document.getElementById('Search-Drawer') || 
                 document.getElementById('Search-Drawer-New');
    } else if (inputId === 'mobile-search-input') {
      container = document.getElementById('mobile-menu');
    }
    
    if (container) {
      this.reinitializeValues(container);
      const searchTerm = this.getQuery(event);
      
      if (!searchTerm.length) {
        if (this.predictiveSearchResults) {
          this.predictiveSearchResults.classList.remove('active');
        }
        return;
      }
      
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.classList.add('active');
      }
      
      this.getSearchResults(searchTerm);
    }
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

getSearchResults(searchTerm) {
  const queryKey = searchTerm.replace(" ", "-").toLowerCase();

  if (!this.predictiveSearchResults) return;
  
  this.predictiveSearchResults.classList.add('loading');

  // Hurtigsøk: produkter (tittel, produkttype, SKU), kategorier og søkeforslag. Utsolgte produkter vises sist.
  const params = [
    `q=${encodeURIComponent(searchTerm)}`,
    `${encodeURIComponent('resources[type]')}=product,collection,query`,
    `${encodeURIComponent('resources[fields]')}=title,product_type,variants.sku`,
    `${encodeURIComponent('resources[limit]')}=10`,
    `${encodeURIComponent('resources[limit_scope]')}=each`,
    `${encodeURIComponent('resources[options][unavailable_products]')}=last`,
    `section_id=predictive-search`
  ].join('&');

  fetch(`${theme.routes.predictive_search_url}?${params}`)
    .then((response) => {
      this.predictiveSearchResults.classList.remove('loading');
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

      this.renderSearchResults(resultsMarkup);
    })
    .catch((error) => {
      throw error;
    });
}


  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    // Get the current search input value
    const currentSearchValue = this.container.querySelector('input[type="search"]').value;
    
    // Get all submit buttons within the results
    const submitButtons = this.predictiveSearchResults.querySelectorAll('[id^="search-results-submit"]');

    submitButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Use the current search value (kun produkter, utsolgte sist)
        if (currentSearchValue) {
          window.location.href = `/search?q=${encodeURIComponent(currentSearchValue)}&type=product&${encodeURIComponent('options[prefix]')}=last&${encodeURIComponent('options[unavailable_products]')}=last`;
        }
      });
    });
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});
document.addEventListener("DOMContentLoaded", () => {
  function bindHandler() {
    const trigger = document.querySelector("a.thb-secondary-area-item.thb-quick-search");
    const searchDrawer = document.querySelector("div#Search-Drawer-New");

    if (trigger && searchDrawer && !trigger.dataset.bound) {
      trigger.dataset.bound = "true";
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        searchDrawer.classList.toggle("active");
        // Markøren i søkefeltet når søket åpnes.
        if (searchDrawer.classList.contains("active")) {
          const field = searchDrawer.querySelector('input[type="search"]');
          if (field) setTimeout(() => field.focus({ preventScroll: true }), 100);
        }
      });
    }
  }
  bindHandler();
  const interval = setInterval(() => {
    bindHandler();
    if (document.querySelector("a.thb-secondary-area-item.thb-quick-search")?.dataset.bound) {
      clearInterval(interval); 
    }
  }, 100);
});


